import {HOTEL_TYPE} from '@/models-hotel';

const hotelType: HOTEL_TYPE = 'P';

export default hotelType;
